<template>
  <footer>
    <base-button class="prev" :class="{disable: lastPrev}" @click="prevMenu()">
      <span>이전 버튼</span>
    </base-button>
    <base-button class="next" :class="{disable: lastNext}" @click="nextMenu()">
      <span>다음 버튼</span>
    </base-button>
  </footer>
</template>

<script>
import BaseButton from '@/components/item/BaseButton.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      menu: this.$router.options.routes,
      nowRouter: this.$route.matched[0].path,
      lastPrev: false,
      lastNext: false
    }
  },
  components: {
    BaseButton
  },
  computed: {
    ...mapGetters([
      'getPageNum'
    ])
  },
  watch: {
    $route (to, from) {
      this.checkLast()
    }
  },
  created () {
    this.menu.forEach((el, index) => {
      if (el.path === this.nowRouter) {
        this.setPageNum(index)
        this.checkLast()
      }
    })
  },
  methods: {
    checkLast () {
      this.lastNext = this.getPageNum === this.menu.length - 1
      this.lastPrev = this.getPageNum === 0
    },
    prevMenu () {
      this.minusPageNum()
      if (this.getPageNum < 0) {
        this.lastPrev = true
        this.setPageNum(0)
        this.$router.push(this.menu[this.getPageNum]?.path)
        this.setNowPath(this.menu[this.getPageNum]?.path)
        return
      }
      this.lastPrev = false
      this.$router.push(this.menu[this.getPageNum]?.path)
      this.setNowPath(this.menu[this.getPageNum]?.path)
    },
    nextMenu () {
      if (this.getPageNum >= this.menu.length - 1) {
        this.lastNext = true
        this.setPageNum(this.menu.length - 1)
        this.$router.push(this.menu[this.getPageNum]?.path)
        this.setNowPath(this.menu[this.getPageNum]?.path)
        return
      }
      this.plusPageNum()
      this.lastNext = false
      this.$router.push(this.menu[this.getPageNum]?.path)
      this.setNowPath(this.menu[this.getPageNum]?.path)
    },

    ...mapMutations([
      'plusPageNum',
      'minusPageNum',
      'setPageNum',
      'setNowPath'
    ])
  }
}
</script>

<style lang="scss">
@import '@/styles/_variable.scss';

footer {
  position: relative;
  height: 108px;
  margin-top: 50px;
  padding: 0 65px;
  box-sizing: border-box;
  .btn {
    position: absolute;
    bottom: 60px;
    &.prev {
      left: 65px;
    }
    &.next {
      left: 133px;
    }
    &.disable {
      cursor: default;
    }
  }
}
</style>
